var _defs, _rect, _path, _ellipse, _g, _path2, _rect2, _path3, _rect3, _path4, _line, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f1e5;}.cls-2{fill:#2ca0ff;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#fd8606;}.cls-5{fill:#f4e211;}.cls-6,.cls-7{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-6{stroke:#000;}.cls-7{stroke:#fff;}.cls-8{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 733.6,
    cy: 558.31,
    rx: 193.65,
    ry: 217.12
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 679.05,
    y: 232.09,
    width: 85.85,
    height: 102.58,
    rx: 34.46
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M553,840.3l-28,66.07a44.65,44.65,0,0,0,41.1,62.06H877.57a44.65,44.65,0,0,0,41.59-60.87L892,838Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 733.6,
    cy: 558.31,
    rx: 193.65,
    ry: 217.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M657.16,639.38l22,14.5A235,235,0,0,1,728.58,494.3a186.11,186.11,0,0,0,18.67,113.5l10.94-45.53a230.18,230.18,0,0,1,46.56,122.09c1.84,24.59-.48,50-11,72.29s-30.21,41-54.25,46.49c-61.66,14-93.81-64.26-93.1-113.35A129.4,129.4,0,0,1,657.16,639.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M676.79,686.74a49.33,49.33,0,0,1,25,23l5.67-80.11c34.74,17.69,58.25,55.53,58.72,94.5.15,12.39-1.95,25.07-8.11,35.82s-16.76,19.34-29,21.14c-20.44,3-36.07-17.1-45.4-32.82C672.81,730,669.79,706.92,676.79,686.74Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M634.21,317.72H816A51.23,51.23,0,0,1,867.26,369v20.23a12,12,0,0,1-12,12H595a12,12,0,0,1-12-12V369a51.23,51.23,0,0,1,51.23-51.23Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 529.52,
    y: 384.23,
    width: 402.94,
    height: 31.3,
    rx: 15.65
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M573.7,729.79H875a34,34,0,0,1,33,41.93L892,838,556.9,832.81l-16-60.32A34,34,0,0,1,573.7,729.79Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 539.95,
    y: 823.02,
    width: 372.95,
    height: 34.56,
    rx: 17.28
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M722,57.24A122.31,122.31,0,1,0,844.28,179.55,122.3,122.3,0,0,0,722,57.24Zm0,217.61a95.3,95.3,0,1,1,95.3-95.3A95.3,95.3,0,0,1,722,274.85Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 619.57,
    y1: 369.84,
    x2: 826.62,
    y2: 369.84
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M710.28,243.75a31.87,31.87,0,0,0-11.8,40.67"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M916.53,392.26a11.1,11.1,0,0,1-7,16.36"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M633.56,745.68l161.42.26"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M712.43,874.69l145.83-3.8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M544.63,911.15c-5.17,4.89-6.11,13.25-3.27,19.79s8.84,11.3,15.45,14,13.81,3.45,20.92,3.81"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M871.47,745.21A16.21,16.21,0,0,1,893,762.87a9.43,9.43,0,0,1-2,4.87,5.16,5.16,0,0,1-4.77,1.81,3.61,3.61,0,0,1-2.88-3.89,9.32,9.32,0,0,1,1.38-2.79,3,3,0,0,0,.26-3c-.89-1.37-3.15-.81-4.15.48s-1.28,3-2.1,4.41-2.67,2.55-4,1.66c-1.2-.79-1.17-2.56-.73-3.93s1.15-2.75.85-4.15c-.42-2-2.62-3-4.57-3.52s-4.18-1.08-5.21-2.83c-1.38-2.36.48-5.55,3-6.56s5.4-.49,8.09,0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M816.14,330.83c2.5,1.35,5.29,2.61,6.31,5.49a3.68,3.68,0,0,1-1.52,4.54c-3.07,1.65-6.55-2.78-9.46-1.15a3.22,3.22,0,0,0-1.08,4.37c1.3,2.41,4,3,6.56,3.22,2.1.16,4.29.14,6.21,1a11.59,11.59,0,0,1,4.79,5,44.68,44.68,0,0,0,3.59,6c1.69,2.09,4.29,3.7,7,3a4.07,4.07,0,0,0,3.19-3.4c.23-2.05-1.3-3.49-2.8-4.62s-3.21-2.28-3.54-4.3a2.46,2.46,0,0,1,1.36-2.72c1.69-.69,3.08.92,3.85,2.4s1.48,3,3,3.29c6.9,1.52.72-8.53-.56-10-2.88-3.4-5.57-7.05-8.53-10.36-4.06-4.54-10.67-7.25-17-7.32a3,3,0,0,0-1.41,5.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects08);
export default __webpack_public_path__ + "static/media/objects-08.69cb00afc7e96d55b6d80dd9c1ef953d.svg";
export { ForwardRef as ReactComponent };